import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../components/ui/button';
import { NotFoundSeo } from '../seo/PageSeo';
import { homePath, DEFAULT_LANG, LANGS } from '../seo/seoConfig';

export default function NotFoundPage() {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || DEFAULT_LANG).slice(0, 2);
  const home = homePath(LANGS.includes(lang) ? lang : DEFAULT_LANG);

  return (
    <main className="min-h-screen flex items-center justify-center px-4 pt-16" data-testid="not-found-page">
      <NotFoundSeo />
      <div className="text-center">
        <p className="text-7xl font-bold text-blue-600 mb-4">404</p>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">{t('notFound.title')}</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-8">{t('notFound.text')}</p>
        <Button asChild className="bg-blue-600 hover:bg-blue-700 text-white">
          <Link to={home} data-testid="not-found-home-link">{t('notFound.back')}</Link>
        </Button>
      </div>
    </main>
  );
}
